import { cn } from '@/lib/utils'
import { Dialog as DialogPrimitive } from 'radix-ui'
import { HTMLProps } from 'react'

/** `wrap` sai do `HTMLProps` — lá é o atributo de `<textarea>`, uma string. */
interface TitleProps extends Omit<HTMLProps<HTMLSpanElement>, 'wrap'> {
    children?: React.ReactNode
    BoxProps?: HTMLProps<HTMLDivElement>
    /**
     * Título em várias linhas, em vez de uma linha só que rola na horizontal.
     * Para pergunta de confirmação, que costuma trazer o nome do registro.
     */
    wrap?: boolean
}

export type { TitleProps as DialogTitleProps }

/**
 * `DialogPrimitive.Title` sem estilo próprio (`asChild`): é ele que dá nome ao
 * diálogo para o leitor de tela e evita o aviso do Radix por título ausente.
 */
export function Title({ children, BoxProps, wrap, ...props }: TitleProps) {
    return (
        <DialogPrimitive.Title asChild>
            <span
                {...props}
                className={cn(
                    'overflow-y-hidden overflow-x-auto',
                    wrap && 'overflow-x-hidden',
                    'p-4 text-lg font-medium min-h-fit',
                    props.className,
                )}
            >
                <div
                    {...BoxProps}
                    className={cn(
                        'flex flex-row flex-nowrap',
                        'px-2 sm:px-4 justify-between items-center',
                        'min-w-max gap-8',
                        // `min-w-max` é o que segura tudo em uma linha; sem ele
                        // a linha quebra e o texto longo passa a caber.
                        wrap && 'min-w-0 flex-wrap wrap-break-word',
                        BoxProps?.className,
                    )}
                >
                    {children}
                </div>
            </span>
        </DialogPrimitive.Title>
    )
}

Title.isTituloDoDialogo = true
